import { BankRegNr } from '@/domain/session';

import { useSession } from '@components/app/Session';

export const useIsHaugesund = (): boolean => {
    const session = useSession();
    return session?.bank?.registrationNumber === BankRegNr.HAUGESUND;
};
